import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { ProductService } from 'src/app/features/products/product.service';
import { PromotionsService } from '../../promotions.service';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-promo-code-import',
  templateUrl: './promo-code-import.component.html',
  styleUrls: ['./promo-code-import.component.scss']
})
export class PromoCodeImportComponent extends FeaturesBaseComponent implements OnInit {

  fileToUpload: File = null;
  importPromocodeForm: FormGroup;
  fileuploaded: boolean = false;





  constructor(
    private fb: FormBuilder,
    private router: Router,
    public dialog: MatDialog,
    private promotionServices: PromotionsService
  ) {
    super();

  }

  ngOnInit(): void {

    this.importPromocodeForm = this.fb.group({
      file: ['', [Validators.required]],
    })
  }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
    this.fileuploaded = true;
  }

  charMask(rawValue: string): RegExp[] {
    const mask = /^[A-Z|a-z|0-9| ]+$/;
    const strLength = String(rawValue).length;
    const nameMask: RegExp[] = [];

    for (let i = 0; i <= strLength; i++) {
      nameMask.push(mask);
    }

    return nameMask;

  }
  onCancel() { this.router.navigate(['features/promotions/ocassion-rewards']); }
  onSubmit() {

    if (this.importPromocodeForm.valid) {
      const dialogRef = this.dialog.open(DialogComponent, {
        data: {
          message: 'pages.placeholders.Areyousureyouwanttosavethechanges',
          buttonText: {
            ok: 'pages.placeholders.Save',
            cancel: 'pages.placeholders.cancel'
          }
        }
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {

          this.promotionServices.postFile(this.fileToUpload).subscribe(res => {


            if (res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_101") || res.responseStatus == 'Success') {
              //alert("Hello123")
              // let _message = 'Import completed successfully'
              let data: any = res;
              let resData = data.data
              if (data && resData != null) {
                let csvData = "data:text/csv;charset=utf-8,"
                  + resData.map(e => e.join(",")).join("\n");
                saveAs(csvData, "Promocode.csv")
              }
              let _message = 'Total Excel Records :' + res.data.length + ' Rows Inserted :' + res.data.length + ' Rows Updated :' + res.data.length + '  Import completed successfully'
              this.toastrService.success(_message, 'Success', {
                timeOut: 3000,
              });
              this.router.navigate(['features/promotions/ocassion-rewards'])
              return;
            } else {
              Swal.fire(
                {
                  title: res.responseStatus,
                  text: res.userMessage,
                  icon: 'error',
                  timer: 2000
                }
              )
              this.router.navigate(['features/promotions/ocassion-rewards/import-promo-code'])
            }

          });

        } else {
          //alert("Hello");
          this.router.navigate(['features/promotions/ocassion-rewards/import-promo-code']);
        }
      });

    }
    //
  }



}
